// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"6a408832","252":"b2f04ef1","935":"dfe24342"}[chunkId] + ".chunk.js";
};